export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500/10 via-accent-100/50 to-background-50 rounded-2xl border border-primary-200/50 p-8 md:p-12">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  移动观影 · 随时随地
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                  51影院移动版全面适配手机和平板设备，无论在地铁通勤还是旅行途中，打开浏览器即可享受超清画质免广告的流畅观影体验。支持流量节省模式，让观影更省心。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <div className="w-full sm:w-auto px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white font-medium text-sm rounded-full transition-colors whitespace-nowrap text-center cursor-pointer flex items-center justify-center gap-2">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-apple-fill text-white"></i>
                    </span>
                    iOS 客户端
                  </div>
                  <div className="w-full sm:w-auto px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white font-medium text-sm rounded-full transition-colors whitespace-nowrap text-center cursor-pointer flex items-center justify-center gap-2">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-android-fill text-white"></i>
                    </span>
                    Android 客户端
                  </div>
                </div>
                <p className="text-xs text-foreground-400 mt-4">
                  也可直接通过手机浏览器访问，无需下载即可观影
                </p>
              </div>

              <div className="flex-shrink-0">
                <div className="relative w-48 h-80 md:w-56 md:h-96 rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20warm%20cinematic%20design%2C%20dark%20theme%20with%20amber%20and%20crimson%20accents%2C%20film%20poster%20thumbnails%2C%20clean%20minimal%20UI%2C%20modern%20layout&width=560&height=960&seq=app-mock&orientation=portrait"
                    alt="51影院移动端界面"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}